<template>
  <div>
    <h2 v-if="title">{{ title }}</h2>
    <p v-if="!trips.length" class="empty-state">{{ emptyText }}</p>
    <ul v-else class="track-list">
      <TripCard
        v-for="trip in trips"
        :key="trip.id"
        :trip="trip"
        :show-delete="showDelete"
        @select="$emit('select', $event)"
        @delete="$emit('delete', $event)"
      />
    </ul>
  </div>
</template>

<script setup>
import TripCard from './TripCard.vue'

defineProps({
  trips: {
    type: Array,
    default: () => [],
  },
  title: {
    type: String,
    default: '',
  },
  emptyText: {
    type: String,
    default: 'Пока нет поездок.',
  },
  showDelete: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['select', 'delete'])
</script>
